// Uppercase the very first character only — leaves the rest of the user's
// input untouched. Used for asset names so existing acronyms like "AC" or
// "PLC" survive intact (titleCase would lowercase them).
export default function capitalizeFirst(str) {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}
